import { useState } from "react";
import { api_chatbot } from "./api";
import { useMutation } from "react-query";

const useMutationAskQuestion = () => {
    const [discussion, setDiscussion] = useState([]);

    const { data, isLoading, mutate, reset } = useMutation(
        api_chatbot.ask_question,
        {
            onSuccess: (data) => {
                setDiscussion((oldState) => {
                    return [oldState, data];
                });
            },
        }
    );

    return {
        data,
        discussion,
        isLoading,
        mutate: (question) => mutate({ question }),
        reset,
    };
};

export default useMutationAskQuestion;
